import script from "./KanaView.vue?vue&type=script&setup=true&lang=js"
export * from "./KanaView.vue?vue&type=script&setup=true&lang=js"

import "./KanaView.vue?vue&type=style&index=0&id=fd04a338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd04a338"]])

export default __exports__